export const printHtml = function (htmlContent, titleContent) {
  
  if (!htmlContent) return
      
  try {        
    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = 'none'
    iframe.style.visibility = 'hidden'
    document.body.appendChild(iframe)

        
    const doc = iframe.contentWindow.document
    doc.open()
    doc.write(`
        <html>
          <head>
            <title>${titleContent}</title>
            <style>              
              * { 
                box-sizing: border-box !important; 
                -webkit-print-color-adjust: exact !important; 
                print-color-adjust: exact !important;
              }
              
              body { 
                margin: 0; 
                padding: 0; 
                font-family: sans-serif;
              }             
              .main-container {
                width: 100% !important;
                max-width: 600px;
                margin: 0 auto;
              }

              @media print {
                @page { margin: 1cm; } 
              }
            </style>
          </head>
          <body>
            ${htmlContent}
          </body>
        </html>
      `)
    doc.close()
    iframe.contentWindow.focus()     
    setTimeout(() => {
      iframe.contentWindow.print()     
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 1000)
    }, 500)

  } catch (error) {
    throw error
  }
}